import * as React from "react";
import { createContext, createElement, useContext, useMemo } from "react";
export function createStackContext() {
    var useStackContext = function useStackContext() {
        var values = useContext(CONTEXT);
        return useMemo(function() {
            var oo = [];
            // Walk up the stack and get just the values out of it. If we hit null,
            // we know we are at the root node that has no parents. Using a for loop
            // here instead of recursion, but recursion would also work fine.
            for(var p = values; p !== null; p = p.parent)oo.unshift(p.value);
            return oo;
        }, [
            values
        ]);
    };
    var CONTEXT = createContext(null);
    var StackContextProvider = function(param) {
        var value = param.value, children = param.children;
        var parent = useContext(CONTEXT);
        var val = useMemo(function() {
            return {
                parent: parent,
                value: value
            };
        }, [
            value,
            parent
        ]);
        return createElement(CONTEXT.Provider, {
            value: val
        }, children);
    };
    return {
        StackContextProvider: StackContextProvider,
        useStackContext: useStackContext
    };
}
